import React, { useState } from 'react';
import moment from 'moment';
import { Box } from '@mui/material';
import { Flex, AGTable } from '../../components';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import QuestionIcon from '@mui/icons-material/QuestionMark';
import CircularProgress from '@mui/material/CircularProgress';

const JobRow = ({ description, status, progress }) => {
  const getIcon = () => {
    switch (status) {
      case 'completed':
        return <DoneIcon sx={{ color: 'green' }} />;
      case 'processing':
        return <CircularProgress size={15} />;
      case 'pending':
        return <CircularProgress size={15} />;
      case 'failed':
        return <CloseIcon sx={{ color: 'red' }} />;
      default:
        return <QuestionIcon />;
    }
  };

  const icon = getIcon();
  const subtextStyle = {
    color: 'grey',
    ml: 1,
    fontStyle: 'italic',
    textWrap: 'nowrap',
  };
  return (
    <Flex.H>
      <Box sx={{ mr: 1 }}>{icon}</Box>
      <Box>{description || 'No title'}</Box>
      {['pending'].includes(status) && <Box sx={subtextStyle}>(Pending)</Box>}
      {['processing'].includes(status) && <Box sx={subtextStyle}>({progress || 0}%)</Box>}
    </Flex.H>
  );
};

const columns = [
  {
    headerName: 'Jobs (Last 7 days)',
    flex: 2,
    sortable: false,
    resizable: false,
    suppressHeaderMenuButton: true,
    contextMenuItems: [],
    wrapText: true,
    autoHeight: true,

    cellRenderer: ({ data }) => <JobRow {...data} />,
  },
  {
    headerName: '',
    flex: 1,
    sortable: false,
    resizable: false,
    suppressHeaderMenuButton: true,
    contextMenuItems: [],
    wrapText: true,
    autoHeight: true,

    cellRenderer: ({ data }) => (
      <Box sx={{ color: 'grey', ml: 1, fontStyle: 'italic' }}>
        {moment(data.audit?.createdDate).fromNow()}
      </Box>
    ),
  },
];

const AsyncJobs = ({ jobs }) => {
  const [tableApi, setTableApi] = useState();

  return (
    <Flex.V
      sx={{
        boxShadow: '0px 8px 8px -8px rgba(0,0,0,0.1) inset',
        backgroundColor: '#f7fafd',
      }}
    >
      <Box sx={{ height: 200, minWidth: 600, '.ag-header': { height: '20px' } }}>
        <AGTable
          selectionModel="singleRow"
          getRowId={({ data }) => data._id}
          headerHeight={30}
          rowData={jobs}
          colDefs={columns}
          isMoveable={false}
          rowHeight={30}
          onUpdate={(api) => setTableApi(api)}
        />
      </Box>
    </Flex.V>
  );
};

AsyncJobs.propTypes = {};

export default AsyncJobs;
